import { saveProject } from '../auth/cloud';
import { useStore } from './store';

let timer: number | undefined;
let saving = false;
let pending: { id: string; doc: unknown } | null = null;

/**
 * Saves the open cloud project shortly after each change, one save at a time. A save that finds
 * someone else's newer version stops autosaving and says so, rather than overwriting their work.
 */
export function startCloudSync(): () => void {
  return useStore.subscribe((state, prev) => {
    if (state.projectHome !== 'cloud' || !state.doc || !state.projectId) return;
    if (state.doc === prev.doc) return;
    useStore.getState().setSaveState('saving');
    window.clearTimeout(timer);
    timer = window.setTimeout(() => void flush(), 600);
  });
}

async function flush(): Promise<void> {
  const { doc, projectId, cloudVersion, projectHome } = useStore.getState();
  if (projectHome !== 'cloud' || !doc || !projectId) return;
  if (saving) { pending = { id: projectId, doc }; return; }
  saving = true;
  try {
    const result = await saveProject(projectId, doc, cloudVersion);
    const store = useStore.getState();
    if ('error' in result) {
      store.setSaveState('error');
      store.notify(result.conflict ? result.error : `Could not save: ${result.error}`);
      return;
    }
    store.setCloudVersion(result.version);
    // only clear the indicator if nothing changed while we were saving
    if (useStore.getState().doc === doc) store.setSaveState('saved');
  } finally {
    saving = false;
    if (pending) { pending = null; void flush(); }
  }
}
